import { MaterialCommunityIcons } from "@expo/vector-icons";
import type { ReactNode } from "react";
import { Pressable, StyleSheet, View } from "react-native";
import { Text } from "react-native-paper";

import { colors, fonts, spacing, typography } from "@/lib/theme";

/** Shared navigation for assessment sections and visit clarifications. */
export function AssessmentScreenHeader({
    title,
    onBack,
    status
}: {
    title: string;
    onBack: () => void;
    status?: ReactNode;
}) {
    return (
        <View style={styles.header}>
            <Pressable
                onPress={onBack}
                accessibilityRole="button"
                accessibilityLabel="Back"
                style={styles.headerBack}
                hitSlop={12}
            >
                <MaterialCommunityIcons name="chevron-left" size={22} color={colors.teal500} />
                <Text style={styles.headerBackText}>Back</Text>
            </Pressable>
            <View style={styles.headerCenter}>
                <Text style={styles.headerTitle} numberOfLines={1}>
                    {title}
                </Text>
            </View>
            <View style={styles.headerStatus}>{status}</View>
        </View>
    );
}
export const assessmentScreenStyles = StyleSheet.create({
    container: { flex: 1, backgroundColor: colors.background },
    scroll: { flex: 1 },
    content: { paddingBottom: spacing["2xl"] }
});
const styles = StyleSheet.create({
    header: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        paddingHorizontal: spacing.base,
        paddingVertical: spacing.md,
        backgroundColor: colors.surface,
        borderBottomWidth: 1,
        borderBottomColor: colors.border
    },
    headerBack: {
        flexDirection: "row",
        alignItems: "center",
        gap: 2,
        minWidth: 60
    },
    headerBackText: {
        fontFamily: fonts.semiBold,
        fontSize: 14,
        color: colors.teal500
    },
    headerCenter: {
        flex: 1,
        alignItems: "center"
    },
    headerTitle: {
        ...typography.h2,
        color: colors.ink
    },
    headerStatus: {
        minWidth: 60,
        alignItems: "flex-end"
    }
});
